import React, { Component } from 'react';
import classnames from 'classnames';
import styles from './styles.scss';

export default class LodIcon extends Component {
  handleClick = () => {
    if (this.props.onClick && !this.props.disabled) {
      this.props.onClick();
    }
  };

  render() {
    const { icon, className } = this.props;
    let iconClass = `slIcon_${icon}`;

    return (
      <i
        className={classnames('slIcon', iconClass, className, {
          [styles.disabled]: this.props.disabled
        })}
        onClick={this.handleClick}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/util/lodIcon/index.js